export enum UserType {
    debtor = 'DEBTOR',
}

export enum Permission {
    All = 'ALL',
    // Add other permissions as needed
}

export enum PartnerPermission {
    All = 'ALL',
    Accounts = 'ACCOUNTS',
    Companies = 'COMPANIES',
    Invoices = 'INVOICES'
}

export interface User {
    id: string;
    email: string;
    company: string;
    type: UserType;
    createdAt: number;
    expiredAt: number;
    username: string;
    permissions: Permission[];
    partnerPermissions: PartnerPermission[];
}
